import { createStore, applyMiddleware, compose } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import rootReducer from './redux/reducers';
import { loadState } from './loadState';

const initialState = {};
const persistedState = loadState();
const middleware = [thunk];

const devTools =
  process.env.NODE_ENV === 'production'
    ? applyMiddleware(...middleware)
    : composeWithDevTools(applyMiddleware(...middleware));

export const store = createStore(
  rootReducer,
  // initialState,
  // persistedState,
  // composeWithDevTools(applyMiddleware(...middleware))
  devTools
);
// store.subscribe(()=>{
//   localStorage.setItem('child', JSON.stringify(store.getState().child))
// })

export default store;
